import moment from "moment/moment";
import { useTranslation } from "react-i18next";

const BankHistory = ({ history }) => {
  const { t } = useTranslation();

  const renderCard = (item) => {
    if (item?.entry_type === "purchase") {
      return (
        <div key={item.id} className="flex items-center justify-between">
          <div className="flex">
            <div className="border-[2px] border-[#3B3C36] bg-white text-center text-[34px] font-sharetech p-2 px-4 w-[100px] text-sangati-orange">
              {item.credits}
            </div>
            <div className="flex flex-col">
              <div className="text-14 pl-[6px] font-semibold">
                {t("purchased")}
              </div>
              <div className="text-[8px] pl-[6px] mb-1">
                {moment(item.created_at).format("DD MMMM YYYY")}
              </div>
              <div className="border-[2px] border-l-0 border-[#3B3C36] mt-auto p-1 text-black font-sharetech text-center w-[50px] bg-white">
                
                {item.balance}
              </div>
            </div>
          </div>
          <div>
            {item.receipt_url && (
              <a href={item.receipt_url} target="_blank" rel="noopener noreferrer">
                <img src="/icons/download1.svg" alt="download" />
              </a>
            )}
          </div>
        </div>
      );
    }

    if (item?.entry_type === "initial_free") {
      return (
        <div key={item.id} className="flex items-center justify-between">
          <div className="flex">
            <div className="border-[2px] border-[#3B3C36] bg-white text-center text-[34px] font-sharetech p-2 px-4 w-[100px]  text-sangati-orange">
               {item.credits}
            </div>
            <div className="flex flex-col">
              <div className="text-14 pl-[6px] font-semibold">
                {t("initialFree")}
              </div>
              <div className="text-[8px] pl-[6px] mb-1">
                {moment(item.created_at).format("DD MMMM YYYY")}
              </div>
              <div className="border-[2px] border-l-0 border-[#3B3C36] mt-auto p-1 text-black font-sharetech text-center w-[50px] bg-white">
               
                {item.balance}
              </div>
            </div>
          </div>
          {/* <div>
            <img src="/icons/download1.svg" alt="download" />
          </div> */}
        </div>
      );
    }

    if (item?.entry_type === "sign_up_bonus") {
      return (
        <div key={item.id} className="flex items-center justify-between">
          <div className="flex">
            <div className="border-[2px] border-[#3B3C36] bg-white text-center text-[34px] font-sharetech p-2 px-4 w-[100px]  text-sangati-orange">
             {item.credits}
            </div>
            <div className="flex flex-col">
              <div className="text-14 pl-[6px] font-semibold">
                {t("signUpBonus")}
              </div>
              <div className="text-[8px] pl-[6px] mb-1">
                {moment(item.created_at).format("DD MMMM YYYY")}
              </div>
              <div className="border-[2px] border-l-0 border-[#3B3C36] mt-auto p-1 text-black font-sharetech text-center w-[50px] bg-white">
                
                 {item.balance}
              </div>
            </div>
          </div>
          {/* <div>
            <img src="/icons/download1.svg" alt="download" />
          </div> */}
        </div>
      );
    }

    if (item.entry_type === "echo") {
      return (
        <div key={item.id} className="flex items-center justify-between">
          <div className="flex">
            <div className="border-[2px] border-[#3B3C36] bg-white text-center text-[34px] font-sharetech p-2 px-4 w-[100px]  text-sangati-orange">
               {item.credits}
            </div>
            <div className="flex flex-col">
              <div className="text-14 pl-[6px] font-semibold flex gap-1 items-center">
                <img src="/icons/incoming.svg" alt="incoming" />
                <span className="text-sangati-orange font-sharetech uppercase">
                  {t("echo")}
                </span>
              </div>
              <div className="text-[8px] pl-[6px] mb-1">
                {moment(item.created_at).format("DD MMMM YYYY")}
              </div>
              <div className="border-[2px] border-l-0 border-[#3B3C36] mt-auto p-1 text-black font-sharetech text-center w-[50px] bg-white">
               
                {item.balance}
              </div>
            </div>
          </div>
          <div>
            <img src="/icons/forwardicon.svg" alt="forward" />
          </div>
        </div>
      );
    }

    if (item.entry_type === "spent") {
      return (
        <div key={item.id} className="flex items-center justify-between">
          <div className="flex">
            <div className="border-[2px] border-[#3B3C36] bg-white text-center text-[34px] font-sharetech p-2 px-4 w-[100px] text-sangati-green">
               {item.credits}
            </div>
            <div className="flex flex-col">
              <div className="text-14 pl-[6px] font-semibold flex gap-1 items-center">
                <img src="/icons/outgoing.svg" alt="outgoing" />
              </div>
              <div className="text-[8px] pl-[6px]">
                {moment(item.created_at).format("DD MMMM YYYY")}
              </div>
              <div className="border-[2px] border-l-0 border-[#3B3C36] mt-auto p-1 text-black font-sharetech text-center w-[50px] bg-white">
               
                {item.balance}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  return <div className="flex flex-col gap-2">{history.map(renderCard)}</div>;
};

export default BankHistory;
